/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { POLLERCONFIGURATIONINFO } from '../model/pOLLERCONFIGURATIONINFO';
import { POLLERCONFIGURATIONUPDATEENTITY } from '../model/pOLLERCONFIGURATIONUPDATEENTITY';
import { TRANSACTIONINFO } from '../model/tRANSACTIONINFO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PollerRelatedOperationService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Delete poller configuration for the card group.
     * @param cardGroupId Identifier of the card group, for which poller configuration will be deleted.
     * @param pollerType Type of poller for which configuration updates will be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdPollerDelete(cardGroupId: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardGroupsCardGroupIdPollerDelete(cardGroupId: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardGroupsCardGroupIdPollerDelete(cardGroupId: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardGroupsCardGroupIdPollerDelete(cardGroupId: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPollerDelete.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardGroupsCardGroupIdPollerDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/poller/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Returns configuration for specified poller for specified card group
     * @param cardGroupId Identifier of the card group, for which poller configuration will be returned.
     * @param pollerType Type of poller for which poller configuration will be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdPollerGet(cardGroupId: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<POLLERCONFIGURATIONINFO>;
    public cardGroupsCardGroupIdPollerGet(cardGroupId: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POLLERCONFIGURATIONINFO>>;
    public cardGroupsCardGroupIdPollerGet(cardGroupId: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POLLERCONFIGURATIONINFO>>;
    public cardGroupsCardGroupIdPollerGet(cardGroupId: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPollerGet.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardGroupsCardGroupIdPollerGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<POLLERCONFIGURATIONINFO>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/poller/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Create new card group poller configuration.
     * @param cardGroupId Identifier of the card group, for which poller configuration will be created
     * @param pollerType Type of poller for which configuration will be created
     * @param cardGroupPollerConfiguration New card group poller configuration. All fields of update_entity are optional. If some field is not specified, this field will not be updated on card.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdPollerPost(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardGroupsCardGroupIdPollerPost(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardGroupsCardGroupIdPollerPost(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardGroupsCardGroupIdPollerPost(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPollerPost.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardGroupsCardGroupIdPollerPost.');
        }
        if (cardGroupPollerConfiguration === null || cardGroupPollerConfiguration === undefined) {
            throw new Error('Required parameter cardGroupPollerConfiguration was null or undefined when calling cardGroupsCardGroupIdPollerPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/poller/`,
            cardGroupPollerConfiguration,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update poller configuration.
     * @param cardGroupId Identifier of the card group, for which poller configuration will be updated
     * @param pollerType Type of poller for which configuration will be updated
     * @param cardGroupPollerConfiguration New card group poller configuration. All fields of update_entity are optional. If some field is not specified, this field will not be updated on card.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdPollerPut(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardGroupsCardGroupIdPollerPut(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardGroupsCardGroupIdPollerPut(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardGroupsCardGroupIdPollerPut(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPollerPut.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardGroupsCardGroupIdPollerPut.');
        }
        if (cardGroupPollerConfiguration === null || cardGroupPollerConfiguration === undefined) {
            throw new Error('Required parameter cardGroupPollerConfiguration was null or undefined when calling cardGroupsCardGroupIdPollerPut.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/poller/`,
            cardGroupPollerConfiguration,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Returns current configuration for specified poller on the specified card
     * @param eid EID of the card, for which poller configuration will be returned
     * @param pollerType Type of poller for which poller configuration will be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidPollerGet(eid: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<POLLERCONFIGURATIONINFO>;
    public cardsEidPollerGet(eid: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POLLERCONFIGURATIONINFO>>;
    public cardsEidPollerGet(eid: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POLLERCONFIGURATIONINFO>>;
    public cardsEidPollerGet(eid: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidPollerGet.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardsEidPollerGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<POLLERCONFIGURATIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/poller/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete poller configuration updates.
     * @param eid EID of the card, for which poller configuration updates will be deleted
     * @param pollerType Type of poller for which configuration updates will be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidPollerUpdatesDelete(eid: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidPollerUpdatesDelete(eid: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidPollerUpdatesDelete(eid: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidPollerUpdatesDelete(eid: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidPollerUpdatesDelete.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardsEidPollerUpdatesDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/poller/updates`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Returns scheduled updates for specified poller on the specified card. If there is no scheduled updates, empty POLLER_CONFIGURATION_UPDATE_ENTITY will be returned.
     * @param eid EID of the card, for which poller configuration updates will be returned
     * @param pollerType Type of poller for which poller configuration updates will be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidPollerUpdatesGet(eid: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<POLLERCONFIGURATIONUPDATEENTITY>;
    public cardsEidPollerUpdatesGet(eid: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POLLERCONFIGURATIONUPDATEENTITY>>;
    public cardsEidPollerUpdatesGet(eid: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POLLERCONFIGURATIONUPDATEENTITY>>;
    public cardsEidPollerUpdatesGet(eid: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidPollerUpdatesGet.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardsEidPollerUpdatesGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<POLLERCONFIGURATIONUPDATEENTITY>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/poller/updates`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update poller configuration.
     * @param eid EID of the card, for which poller configuration will be updated
     * @param pollerType Type of poller for which configuration will be updated
     * @param updateEntity Card poller configuration updates. All fields of update_entity are optional. If some field is not specified, it will not be updated.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidPollerUpdatesPost(eid: string, pollerType: string, updateEntity: POLLERCONFIGURATIONUPDATEENTITY, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidPollerUpdatesPost(eid: string, pollerType: string, updateEntity: POLLERCONFIGURATIONUPDATEENTITY, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidPollerUpdatesPost(eid: string, pollerType: string, updateEntity: POLLERCONFIGURATIONUPDATEENTITY, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidPollerUpdatesPost(eid: string, pollerType: string, updateEntity: POLLERCONFIGURATIONUPDATEENTITY, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidPollerUpdatesPost.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardsEidPollerUpdatesPost.');
        }
        if (updateEntity === null || updateEntity === undefined) {
            throw new Error('Required parameter updateEntity was null or undefined when calling cardsEidPollerUpdatesPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/poller/updates`,
            updateEntity,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Cancel current queue for card. If &#39;includeCurrent&#39; flag &#x3D;&#x3D; true and there is running request in queue, retry_counter of the running request will be set to max_retry value, and all other requests will be cancelled.
     * @param eid EID of the card, for which queue will be canceled
     * @param includeCurrent Cancel retries for the active request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidQueueDelete(eid: string, includeCurrent: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidQueueDelete(eid: string, includeCurrent: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidQueueDelete(eid: string, includeCurrent: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidQueueDelete(eid: string, includeCurrent: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidQueueDelete.');
        }
        if (includeCurrent === null || includeCurrent === undefined) {
            throw new Error('Required parameter includeCurrent was null or undefined when calling cardsEidQueueDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (includeCurrent !== undefined) {
            queryParameters = queryParameters.set('include_current', <any>includeCurrent);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/queue/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Returns current queue of transactions for specified card
     * @param eid EID of the card, for which queue will be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidQueueGet(eid: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TRANSACTIONINFO>>;
    public cardsEidQueueGet(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TRANSACTIONINFO>>>;
    public cardsEidQueueGet(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TRANSACTIONINFO>>>;
    public cardsEidQueueGet(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidQueueGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<TRANSACTIONINFO>>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/queue/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update queue order. If size of queue order in request is smaller than size of current queue, new queue will have order as queue in request and requests, whose IDs were not mentioned in queue order, will be canceled.
     * @param eid EID of the card, for which queue order will be updated
     * @param order New order of transactions specified as a list of transaction_ids
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidQueuePost(eid: string, order?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidQueuePost(eid: string, order?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidQueuePost(eid: string, order?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidQueuePost(eid: string, order?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidQueuePost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (order) {
            order.forEach((element) => {
                queryParameters = queryParameters.append('order', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.post<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/queue/`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Cancel transaction for card.
     * @param eid EID of the card for which transaction will be cancelled
     * @param transactionId ID of the transaction that will be cancelled
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardsEidTransactionsTransactionIdDelete(eid: string, transactionId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardsEidTransactionsTransactionIdDelete(eid: string, transactionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardsEidTransactionsTransactionIdDelete(eid: string, transactionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardsEidTransactionsTransactionIdDelete(eid: string, transactionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eid === null || eid === undefined) {
            throw new Error('Required parameter eid was null or undefined when calling cardsEidTransactionsTransactionIdDelete.');
        }
        if (transactionId === null || transactionId === undefined) {
            throw new Error('Required parameter transactionId was null or undefined when calling cardsEidTransactionsTransactionIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/transactions/${encodeURIComponent(String(transactionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/api/pollerRelatedOperation.service.ts